import { onUnmounted } from 'vue'
import syncMaps from '@/utils/mapbox/sync-move'

// Thin wrapper over sync-move.js that lets the caller rebuild the synced set as
// tiles mount/unmount or per-map sync toggles change. Only instances passed to
// rebuild() participate; a map with sync off is simply excluded and pans freely.
export function useMapSync() {
  let cleanup: (() => void) | null = null

  const teardown = () => {
    if (cleanup) {
      cleanup()
      cleanup = null
    }
  }

  const rebuild = (instances: any[]) => {
    teardown()
    if (instances.length >= 2) {
      cleanup = syncMaps(instances)
    }
  }

  onUnmounted(teardown)

  return { rebuild, teardown }
}
